import { usePalette } from "@/shared/theme";
import { BankOutlined } from "@ant-design/icons";
import { CSSProperties } from "react";
import { OrganizationNameFragment } from "gql/graphql";
import { hasName } from "@/shared/data-display/localized-value";
import { Hidable, Nothing } from "@/shared/value";
import { Organization } from "../../organization";

export function PersonDepartment({
  data,
}: {
  data?: Hidable<OrganizationNameFragment>;
}) {
  const palette = usePalette();

  // См. `PersonPosition`: пустое подразделение убирает строку вместе с иконкой,
  // скрытое — оставляет.
  if (!hasName(data)) {
    return null;
  }

  return (
    <div
      className="space-x-2 text-[--color]"
      style={{ "--color": palette.neutral[5] } as CSSProperties}
    >
      <BankOutlined style={{ color: palette.neutral[5] }} />
      <Organization.Name data={data} whenEmpty={Nothing} />
    </div>
  );
}
